import {
  GET_CODEPROMOS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_CODEPROMO_SUCCESS,
  ADD_CODEPROMO_FAIL,
  
  UPDATE_CODEPROMO_SUCCESS,
  UPDATE_CODEPROMO_FAIL,
} from "./actionType";

const INIT_STATE = {
  codePromos: [],
  error: {},
};

const CodePromo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CODEPROMOS:
          return {
            ...state,
            codePromos: action.payload.data,
            isCodePromoCreated: false,
            isCodePromoSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CODEPROMOS:
          return {
            ...state,
            error: action.payload.error,
            isCodePromoCreated: false,
            isCodePromoSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_CODEPROMO_SUCCESS:
      return {
        ...state,
        isCodePromoCreated: true,
        codePromos: [...state.codePromos, action.payload.data],
        isCodePromoAdd: true,
        isCodePromoAddFail: false
      };

    case ADD_CODEPROMO_FAIL:
      return {
        ...state,
        error: action.payload,
        isCodePromoAdd: false,
        isCodePromoAddFail: true
      };

    case UPDATE_CODEPROMO_SUCCESS:
      return {
        ...state,
        codePromos: state.codePromos.map(codePromo =>
          codePromo.id === action.payload.id
            ? { ...codePromo, ...action.payload }
            : codePromo
        ),
        isCodePromoUpdate: true,
        isCodePromoUpdateFail: false
      };

    case UPDATE_CODEPROMO_FAIL:
      return {
        ...state,
        error: action.payload,
        isCodePromoUpdate: false,
        isCodePromoUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default CodePromo;
